import * as React from 'react';
import { Checkbox, Tooltip } from '@cimpress/react-components';
import { IconInformationCircle } from '@cimpress-technology/react-streamline-icons';
export const DispatchCheckbox = props => {
    return (React.createElement(Checkbox, { checked: !!props.state[props.id], disabled: props.disabled, onChange: () => props.dispatch({ type: props.id }), label: (React.createElement("span", null,
            props.label,
            props.tooltipContents
                ? (React.createElement(Tooltip, { contents: props.tooltipContents },
                    React.createElement(IconInformationCircle, { style: { verticalAlign: 'middle', marginLeft: '0.25em' } })))
                : null)) }));
};
//# sourceMappingURL=DispatchCheckbox.js.map